import { render, staticRenderFns } from "./compliance-invitation-notification.vue?vue&type=template&id=ac2e6d66"
import script from "./compliance-invitation-notification.vue?vue&type=script&lang=js"
export * from "./compliance-invitation-notification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports